module.exports = __webpack_public_path__ + "images/store_case_study/jungle-pic2_403e40d948bc0b8e556be41d1728d673.png";